import { createI18nText } from '@hilma/netina2all';

const unsubText = createI18nText({
	he: {
		loading: 'טוען',
		suckUnsub: 'הוסרת מרשימת ההודעות הפרסומיות בהצלחה',
		err: 'חלה תקלה, אנא נסה שוב מאוחר יותר'
	},
	en: {
		loading: 'Loading',
		suckUnsub: "You have been successfully unsubscribed",
		err: 'An error occurred, please try again later'
	}
});

export default unsubText;